import { RouterProvider } from 'react-router-dom';
import type { createBrowserRouter } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

interface AppProps {
  router: ReturnType<typeof createBrowserRouter>;
}

export default function App({ router }: AppProps): JSX.Element {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}
